export default "__VITE_ASSET__B$b_K2TE__"